// dont use any rtkQuery hook in this component as this renders on api error
// as well. In case the api breaks and you call the hook here, it will cause infinite loop.

import { FLIGHT_NOT_AVAILABLE, ITINERARY_EXPIRED } from '@/src/constants/itineraryStatus'
import useRedirectToHome from '@/src/hooks/navigation/useRedirectToHome'
import useRedirectToSrp from '@/src/hooks/navigation/useRedirectToSrp'
import { DeviceType } from '@/src/types/deviceType'
import { ErrorType } from '@/src/types/itinerary'
import { useTranslations } from 'next-intl'
import ErrorModal from './errorModal'

export interface ErrorModalWrapperProps {
    errorType: ErrorType
    deviceType: DeviceType
    message?: {
        primary: string
        secondary?: string
    }
    onPrimaryClick?: () => void
    onSecondaryClick?: () => void
}

const ErrorModalWrapper: React.FC<ErrorModalWrapperProps> = ({
    errorType,
    deviceType,
    message,
    onPrimaryClick,
    onSecondaryClick
}) => {
    const redirectToSrp = useRedirectToSrp()
    const goToHome = useRedirectToHome()
    const t = useTranslations('errorModal')
    const ERROR_CONFIGS: Record<
        ErrorType,
        {
            primaryError: string
            secondaryError?: string
            primaryButtonText?: string
            primaryButtonAction: () => void
            secondaryButtonText?: string
            secondaryButtonAction?: () => void
        }
    > = {
        [FLIGHT_NOT_AVAILABLE]: {
            primaryError: message?.primary || `${t('flightNoLongerAvailiable')}`,
            secondaryError: message?.secondary || `${t('chooseAnotherFlight')}`,
            primaryButtonText: `${t('gotIt')}`,
            primaryButtonAction: () => {
                redirectToSrp()
            }
        },
        [ITINERARY_EXPIRED]: {
            primaryError: message?.primary || `${t('itineraryExpired')}`,
            secondaryError: message?.secondary || `${t('createNewItinerary')}`,
            primaryButtonText: `${t('goToHome')}`,
            primaryButtonAction: () => {
                goToHome({ isReloadRequired: true })
            }
        }
        // [PRICE_CHANGED]: {
        //     primaryError: message?.primary || `${t('priceChanged')}`,
        //     secondaryError: message?.secondary || '',
        //     primaryButtonText: `${t('continueToPayment')}`,
        //     primaryButtonAction: () => {
        //         onPrimaryClick?.()
        //     },
        //     secondaryButtonText: `${t('chooseAnotherFlight')}`,
        //     secondaryButtonAction: () => {
        //         redirectToSrp()
        //     }
        // }
    }

    const errorConfig = ERROR_CONFIGS[errorType]

    return (
        <ErrorModal
            isOpen={true}
            primaryError={errorConfig.primaryError}
            secondaryError={errorConfig.secondaryError}
            primaryButtonText={errorConfig.primaryButtonText}
            primaryButtonAction={errorConfig.primaryButtonAction}
            secondaryButtonText={errorConfig.secondaryButtonText}
            secondaryButtonAction={errorConfig.secondaryButtonAction}
        />
    )
}

export default ErrorModalWrapper
